/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom fields request
 * @export
 * @interface CustomFieldRequest
 */
export interface CustomFieldRequest {
    /**
     * Map of custom field key-value pairs
     * @type {{ [key: string]: any; }}
     * @memberof CustomFieldRequest
     */
    customFields: { [key: string]: any; };
}

/**
 * Check if a given object implements the CustomFieldRequest interface.
 */
export function instanceOfCustomFieldRequest(value: object): value is CustomFieldRequest {
    if (!('customFields' in value) || value['customFields'] === undefined) return false;
    return true;
}

export function CustomFieldRequestFromJSON(json: any): CustomFieldRequest {
    return CustomFieldRequestFromJSONTyped(json, false);
}

export function CustomFieldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customFields': json['customFields'],
    };
}

export function CustomFieldRequestToJSON(json: any): CustomFieldRequest {
    return CustomFieldRequestToJSONTyped(json, false);
}

export function CustomFieldRequestToJSONTyped(value?: CustomFieldRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customFields': value['customFields'],
    };
}

